import { Loader, Text } from "@mantine/core";
import React from "react";

function RenderData({ isLoading = false, data = [], render, renderEmpty }) {
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : !data || (Array.isArray(data) && data.length === 0) ? (
        renderEmpty ?? <Text>Pas de données</Text>
      ) : Array.isArray(data) ? (
        data?.map(render)
      ) : (
        render(data)
      )}
    </>
  );
}

export default RenderData;
